import React, { useEffect, useState } from 'react';
import './selector.styles.scss';

const Selector = ({ options, accentColor, onSelectionChange, defaultValue }) => {
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    // Conditionally set the default selected option if provided
    if (defaultValue) {
      setSelectedOption(defaultValue);
    }
  }, [defaultValue]);

  const handleOptionClick = (option) => {
    setSelectedOption(option.value);
    if (onSelectionChange) {
      onSelectionChange(option.value); 
    }
  };

  return (
    <div className="selector-container">
      {options.map((option) => (
        <button
          key={option.value}
          className={`selector-option ${selectedOption === option.value ? 'selected' : ''}`}
          style={{ backgroundColor: selectedOption === option.value ? accentColor : 'transparent' }}
          onClick={() => handleOptionClick(option)}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
};

export default Selector;
